import { Flex } from '@amzn/ring-ui-react-components';
import { Loading, LoadingProps } from './Loading';

export const CenteredLoading = (props: LoadingProps) => (
  <Flex flex={1} justify="center" align="center" data-testid="centered-loading">
    <Loading {...props} />
  </Flex>
);
